import { gql } from 'apollo-boost';

import { SHIFT_APPLICATION_FRAGMENT } from '../fragments/shift-application-fragment';

export const SHIFT_APPLICATION_REJECT_GQL = gql`
  ${SHIFT_APPLICATION_FRAGMENT}
  mutation ShiftApplicationReject($idArray: [ID!]!) {
    shift_application_reject(input: { ids: $idArray }) {
      failures {
        id
        message
      }
      successes {
        message
        shift_application {
          ...shiftApplicationFragment
        }
      }
    }
  }
`;

export const SHIFT_APPLICATION_REJECT_CANCEL_GQL = gql`
  ${SHIFT_APPLICATION_FRAGMENT}
  mutation ShiftApplicationRejectCancel($idArray: [ID!]!) {
    shift_application_reject_cancel(input: { ids: $idArray }) {
      failures {
        id
        message
      }
      successes {
        message
        shift_application {
          ...shiftApplicationFragment
        }
      }
    }
  }
`;
